import { FC } from 'react';
import NewTooltip from './NewTooltip';
import { getIconComponent } from '../../utils/iconMap';

interface ProfileData {
  value: string;
  label: string;
  icon?: string;
}

interface IconRegistrationProfileProps {
  profile: string | ProfileData | null;
}

const IconRegistrationProfile: FC<IconRegistrationProfileProps> = ({ profile }) => {
  
  // ✅ Verificação de segurança
  if (!profile) {
    const IconComponent = getIconComponent('FaRegUser');
    return (
      <NewTooltip content="Profile não encontrado">
        <IconComponent className='text-xl' />
      </NewTooltip>
    );
  }
  
  // ✅ Suporte a ambos os formatos: string (legacy) e ProfileData (novo)
  if (typeof profile === 'string') {
    // ✅ LEGACY: Mapeamento hardcoded para compatibilidade
    const legacyIcons: { [key: string]: string } = {
      "ISSUER": "FaRegUser",
      "RECIPIENT": "LuBadgeDollarSign", 
      "GUARANTOR-RETAIL": "TbLetterV",
      "GUARANTOR-WHOLESALE": "TbLetterA",
      "SIGNATORY": "TbSignature",
      "GUARANTOR": "TbLetterA",
      "CONSENTING_PARTY": "ImManWoman",
      "FINANCIAL_REPRESENTATIVE": "FaUserTie",
      "DRAWEE": "FaFileInvoiceDollar",
    };

    const legacyTooltips: { [key: string]: string } = {
      "ISSUER": "Emitente",
      "RECIPIENT": "Beneficiário",
      "GUARANTOR-RETAIL": "Avalista Varejo",
      "GUARANTOR-WHOLESALE": "Avalista Atacado",
      "SIGNATORY": "Signatário",
      "GUARANTOR": "Avalista",
      "CONSENTING_PARTY": "Anuente",
      "FINANCIAL_REPRESENTATIVE": "Representante Financeiro",
      "DRAWEE": "Sacado",
    };

    const iconName = legacyIcons[profile];
    const IconComponent = getIconComponent(iconName);
    
    return (
      <NewTooltip content={legacyTooltips[profile] || profile}>
        <IconComponent className='text-xl' />
      </NewTooltip>
    );
  }

  // ✅ NOVO: Usar dados dinâmicos do banco
  const IconComponent = getIconComponent(profile.icon || 'FaRegUser');
  
  return (
    <NewTooltip content={profile.label || profile.value}>
      <IconComponent className='text-xl' />
    </NewTooltip>
  );
};

export default IconRegistrationProfile;